import React from 'react'
import styles from 'modules/Services/Network/subcomponents/HighRiskLabel/high-risk.module.scss'
import { Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const HighRiskLabel = ({ size = 'm' }) => {
  return (
    <span
      className={clsx(styles['high-risk_container'], {
        [styles[`high-risk_container_size_${size}`]]: size,
      })}
    >
      <Typography
        variant={size === 's' || size === 'xs' ? 'Body-5' : 'Body-15'}
        color={'Label-Onsurface'}
        component={'span'}
        noWrap
      >
        High Risk
      </Typography>
    </span>
  )
}

export default HighRiskLabel

HighRiskLabel.propTypes = {
  size: PropTypes.oneOf(['xs', 's', 'm']),
}
